import React, { useState } from 'react';
import { Monitor, Smartphone, Code2, Eye } from 'lucide-react';
import { MERGE_TAGS, previewHtml } from './api';

// HTML kod + canlı önizleme (masaüstü/mobil). Şablon ve kampanya editörü ortak kullanır.
export function HtmlEditor({ value, onChange, readOnly, height = 560 }) {
  const [view, setView] = useState('split');
  const [device, setDevice] = useState('desktop');

  const insert = (tag) => {
    const el = document.getElementById('glowy-mail-html');
    if (!el) return onChange(value + tag);
    const { selectionStart: s, selectionEnd: e } = el;
    onChange(value.slice(0, s) + tag + value.slice(e));
    requestAnimationFrame(() => { el.focus(); el.selectionStart = el.selectionEnd = s + tag.length; });
  };

  const btn = (active) => `inline-flex items-center gap-1 px-2 py-1 rounded-md text-[11px] ${active ? 'bg-gray-900 text-white' : 'text-gray-600 hover:bg-gray-100'}`;

  return (
    <div className="rounded-xl border border-gray-200 bg-white overflow-hidden">
      <div className="flex flex-wrap items-center justify-between gap-2 px-3 py-2 border-b border-gray-100">
        <div className="flex gap-1">
          {!readOnly && <button type="button" className={btn(view === 'code')} onClick={() => setView('code')}><Code2 className="w-3 h-3" />HTML</button>}
          {!readOnly && <button type="button" className={btn(view === 'split')} onClick={() => setView('split')}>Split</button>}
          <button type="button" className={btn(view === 'preview' || readOnly)} onClick={() => setView('preview')}><Eye className="w-3 h-3" />Preview</button>
        </div>
        <div className="flex items-center gap-2">
          {!readOnly && (
            <select className="text-[11px] border border-gray-200 rounded-md px-1.5 py-1 text-gray-600" value="" onChange={(e) => e.target.value && insert(e.target.value)}>
              <option value="">Insert merge tag…</option>
              {MERGE_TAGS.map(([tag, label]) => <option key={tag} value={tag}>{tag} — {label}</option>)}
            </select>
          )}
          <div className="flex gap-1">
            <button type="button" className={btn(device === 'desktop')} onClick={() => setDevice('desktop')} title="Desktop"><Monitor className="w-3 h-3" /></button>
            <button type="button" className={btn(device === 'mobile')} onClick={() => setDevice('mobile')} title="Mobile"><Smartphone className="w-3 h-3" /></button>
          </div>
        </div>
      </div>
      <div className="flex" style={{ height }}>
        {!readOnly && view !== 'preview' && (
          <textarea
            id="glowy-mail-html"
            className={`${view === 'split' ? 'w-1/2 border-r border-gray-100' : 'w-full'} h-full resize-none p-3 font-mono text-[11.5px] leading-[1.55] text-gray-800 focus:outline-none`}
            spellCheck={false}
            value={value}
            onChange={(e) => onChange(e.target.value)}
            placeholder="Paste or write email HTML…"
          />
        )}
        {(readOnly || view !== 'code') && (
          <div className={`${!readOnly && view === 'split' ? 'w-1/2' : 'w-full'} h-full bg-gray-100 flex justify-center overflow-auto`}>
            <iframe
              title="Email preview"
              sandbox=""
              srcDoc={previewHtml(value) || '<p style="font-family:Arial;color:#999;padding:24px">Nothing to preview yet</p>'}
              className="bg-white h-full border-0 shadow-sm"
              style={{ width: device === 'mobile' ? 375 : '100%', maxWidth: device === 'mobile' ? 375 : 760 }}
            />
          </div>
        )}
      </div>
    </div>
  );
}

// Gelen kutusu satırı önizlemesi: gönderen · konu · ön başlık
export function InboxPreview({ fromName, subject, preheader }) {
  return (
    <div className="rounded-lg border border-gray-200 bg-white px-3 py-2.5 flex gap-3 items-start">
      <div className="w-8 h-8 rounded-full bg-indigo-100 text-indigo-700 text-xs font-semibold flex items-center justify-center shrink-0">
        {(fromName || '?').slice(0, 1).toUpperCase()}
      </div>
      <div className="min-w-0 text-xs">
        <div className="font-semibold text-gray-900 truncate">{fromName || 'Sender name'}</div>
        <div className="text-gray-900 truncate">{previewHtml(subject) || <span className="text-gray-400">Subject line</span>}</div>
        <div className="text-gray-500 truncate">{previewHtml(preheader) || <span className="text-gray-300">Preview text</span>}</div>
      </div>
    </div>
  );
}
